/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_Up_SubmitInputs */

const cs_billing_top_up_submit = /** @type {(inputs: Billing_Top_Up_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobít`)
};

const en_billing_top_up_submit = /** @type {(inputs: Billing_Top_Up_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top up`)
};

/**
* | output |
* | --- |
* | "Top up" |
*
* @param {Billing_Top_Up_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up_submit = /** @type {((inputs?: Billing_Top_Up_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_Up_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up_submit(inputs)
	return cs_billing_top_up_submit(inputs)
});